export function getVisibilityProps() {
    return { hidden: "hidden", visibilityChange: "visibilitychange" };
}
